import fuzzyLogicSoilAttribute from './fuzzyLogicSoilAttribute';

export const NCCPI = fuzzyLogicSoilAttribute({
  fuzzyLogicRuleName:
    'NCCPI - National Commodity Crop Productivity Index (Ver 3.0)',
  key: 'National Commodity Crop Productivity Index',
  matchRating: false,
  ruleId: '2685',
  shortFormData: { AggregationMethod: 'Weighted Average' },
});
